module.exports = __webpack_public_path__ + "img/药理研究员.cd8f45c8.jpg";